<div class="row footerdiv">
  <hr class="hrcust">
  <div class="row footer-row" #linksdiv>
    <div class="col-xs-12 col-md-8 footer-links">
      <a class="refrem" [routerLink]="['/borrow']">
        <p>Borrow</p>
      </a>
      <a class="refrem" [routerLink]="['/invest']">
        <p>Invest</p>
      </a>

      <a class="refrem" target="_blank" [routerLink]="['/contactus']" (click)="openFromMobile($event)">
        <p>Contact Us</p>
      </a>
      <a class="refrem" target="_blank" [routerLink]="['/partnerwithus']" (click)="openFromMobile($event)">
        <p>Partner With Us</p>
      </a>
      <a class="refrem" target="_blank" [routerLink]="['/faq']" (click)="openFromMobile($event)">
        <p>FAQs</p>
      </a>
      <a class="refrem" target="_blank" [routerLink]="['/team']" (click)="openFromMobile($event)">
        <p>Team</p>
      </a>
      <a class="refrem" target="_blank" href="https://blog.finzy.com/" (click)="openFromMobile($event)">
        <p>Blog</p>
      </a>
      <a class="refrem" target="_blank" [routerLink]="['/terms']" (click)="openFromMobile($event)">
        <p>Terms</p>
      </a>
      <a class="refrem" target="_blank">
        <div class="dropup policy-dropup">
          <span class="dropdown-toggle" data-toggle="dropdown">
            Policies & More
            <span class="caret"></span>
          </span>
          <ul class="dropdown-menu">
            <li><a target="_blank" [routerLink]="['/privacypolicy']" (click)="openFromMobile($event)">Privacy Policy</a>
            </li>
            <li><a [href]="getPolicyFileUrlByName('businessModelProcess')" target="_blank"
                (click)="openFromMobile($event,true)">Business Model</a></li>
            <li><a [routerLink]="['/articles/peer-to-peer-lending']">Peer to Peer Lending</a></li>
            <li><a [href]="getPolicyFileUrlByName('fairPracticeCode')" target="_blank"
                (click)="openFromMobile($event,true)">Fair Practise Code</a></li>
            <li>
              <a [href]="getPolicyFileUrlByName('grevianceRedressalPolicy')" target="_blank"
                (click)="openFromMobile($event,true)">Grievance Redressal Policy</a>
            </li>
            <li>
              <a [href]="getPolicyFileUrlByName('OOCAM')" target="_blank" (click)="openFromMobile($event,true)">Overview
                Of Credit Assessment Methodology</a>
            </li>
            <li>
              <a [href]="getPolicyFileUrlByName('portfolioPerfomance')" target="_blank"
                (click)="openFromMobile($event,true)">Portfolio Performance</a>
            </li>
            <li><a target="_blank" [routerLink]="['/investor-relations']" (click)="openFromMobile($event)">Investor
                Relations</a></li>
          </ul>
        </div>
      </a>
    </div>
    <div class="col-xs-12 col-md-4 social-icons">
      <a class="refrem socicon" href="https://www.facebook.com/finzyindia" rel="nofollow" target="_blank"
        (click)="openFromMobile($event)"><i class="fa fa-facebook soctxt" aria-hidden="true"></i></a>
      <a class="refrem socicon" href="https://www.linkedin.com/company/finzy" rel="nofollow" target="_blank"
        (click)="openFromMobile($event)"><i class="fa fa-linkedin-square soctxt" aria-hidden="true"></i></a>
      <a class="refrem socicon" href="https://www.instagram.com/finzyindia/" rel="nofollow" target="_blank"
        (click)="openFromMobile($event)"><i class="fa fa-instagram soctxt" aria-hidden="true"></i></a>
      <a class="refrem" href="https://twitter.com/finzyindia" rel="nofollow" target="_blank"
        (click)="openFromMobile($event)"><i class="fa fa-twitter soctxt" aria-hidden="true"></i></a>
    </div>
  </div>

  <p class="copyright">
    finzy is owned and operated by Bridge Fintech Solutions Private Limited (CIN : U74999MH2016PTC286583).
    <br />
    © {{getFinancialYear()}} finzy. All rights reserved.
  </p>

  <div class="row ml-md-1">
    <div class="col-sm-12 mb-4">
      <article class="text-details-info">
        <p class="text-details-heading font-weight-bold">Disclaimer</p>
        <p class="text-details">
          It has been brought to our attention that fraudulent activities have been discovered involving people
          pretending to be employees or authorized representatives of <a href="https://finzy.com"
            target="_blank">finzy.com</a> to defraud our customers.
          Please note that the only legitimate domain name for <a href="https://finzy.com" target="_blank">finzy.com
          </a> is www.finzy.com.
          We request you to verify any borrowing or lending opportunity related to Finzy by reaching out to us through
          the ways mentioned below.
          We also request you not to respond with any personal information if you are uncertain about the communication
          and urge you not to send any money to third parties until you have verified with us.
          Please contact us at
          <strong><a href="mailto:support@finzy.com" target="_blank">support@finzy.com</a></strong> or call <strong>9341
            300 300</strong>
          to check borrowing/lending opportunities or report suspicious behavior.
        </p>
      </article>
    </div>
    <div class="col-sm-12 mb-4">
      <article class="text-details-info">
        <p class="text-details-heading font-weight-bold">Risk Disclaimer</p>
        <p class="text-details">
          P2P lending/investment is subject to risks. finzy is a digital marketplace to connect lenders and borrowers.
          We do not guarantee any rate of return or return of lent amount.
          Lending done herein are subject to credit risk and loss might arise out of non performing underlying loans to
          which the lender has an exposure and lenders solely carry risks of any loss arising out of such loans.
        </p>
      </article>
    </div>
    <div class="col-sm-12 mb-5">
      <article class="text-details-info">
        <p class="text-details-heading font-weight-bold">RBI Disclaimer</p>
        <p class="text-details">
          Bridge Fintech Solutions Private Limited (Company) is having a valid Certificate of Registration dated June 28, 2018 issued by the Reserve Bank of India under Section 45 IA of the Reserve Bank of India Act, 1934. 
          However, the RBI does not accept any responsibility or guarantee about the present position as to the financial soundness of the company or for the correctness of any of the statements or representations made or opinions expressed by the company and for repayment of deposits / discharge of liabilities by the company.
        </p>
      </article>
    </div>
  </div>
</div>